export class CamposModificados {
    public idBin: number;
    public bin: string;
    public tipo: String;
    public grupo: String;
    public origenInfo: number;
    constructor(){
       this.idBin=null;
       this.bin=null;
       this.tipo=null;
       this.grupo=null;
       this.origenInfo = null;
	}
}